import { accordionItemStyles, accordionItemTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
import { AccordionItem } from "./accordion-item.js";
/**
 * @public
 * @remarks
 * HTML Element: <fabric-accordion-item>
 */
export const definition = AccordionItem.compose({
    name: `${DesignSystem.prefix}-accordion-item`,
    template: accordionItemTemplate,
    styles: accordionItemStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=accordion-item.definition.js.map